<template>
  <div class="float-content-box">

     <!-- <a href="https://console.hpc.jengcloud.com" target="_blank" class="item-box cloud-chain-no1">
        <div class="show-content">
            <img class="icon" src="@/assets/img/cloud-chain-no1-right-logo.png" width="97px">
            <div class="title">云链壹号</div>
        </div>
    </a>

    <div class="line"></div> -->

    <a href="https://hpc-help.jengcloud.com" target="_blank" class="item-box service-book">
        <div class="show-content">
            <img class="icon" src="@/assets/img/float-service-book-icon.png" width="24px">
            <div class="title">服务手册</div>
        </div>
        <div class="info-box">
            <div class="content-box">
                <div class="text">济南超算用户服务手册</div>
            </div>
        </div>
    </a>

    <div class="line"></div>

    <div class="item-box">
        <div @click="tryHandler" class="show-content">
            <img src="@/assets/img/float-consult-icon.png" width="24px">
            <div class="title">试算</div>
        </div>
    </div>

    <div class="line"></div>

    <div @click="returnTopHandler" class="item-box">
        <div class="show-content">
            <img src="@/assets/img/float-arrow-icon.png" width="24px">
            <div class="title">返回顶部</div>
        </div>
    </div>

    <div class="line"></div>

    <TryDialog :zIndex="888" :visible.sync="tryDialogVisible" />
  </div>
</template>

<script>
import TryDialog from '@/components/TryDialog.vue'

export default {
  name: 'FloatContent',
  components: {
    TryDialog
  },
  data () {
    return {
      tryDialogVisible: false
    }
  },
  methods: {
    returnTopHandler () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    tryHandler () {
      this.tryDialogVisible = true
    }
  }
}

</script>

<style lang="scss" scoped>
.float-content-box{
    position: fixed;
    right: 16px;
    bottom: 20px;
    z-index: 999;
    width: 90px;
    box-sizing: border-box;
    padding: 24px 0;
    padding-bottom: 14px;
    background: linear-gradient( 180deg, #EAF4FF 0%, #B2D3FF 100%);
    border-radius: 12px;
    border: 1px solid #AEC9ED;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    .item-box{
        cursor: pointer;
        .show-content{
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            .title{
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: rgba(77,143,204,0.8);
                transition: all .2s ease-in-out;
            }
            .icon{
                transition: all .2s ease-in-out;
            }
        }

    }

    .line{
        width:24px;
        height: 1px;
        background-color: rgba(115,124,145,0.4);
    }

    .service-book{
        position: relative;

        &:hover{
            .info-box{
                width: 272px;
                opacity: 1;
            }
            .title{
                opacity: 0;
            }
            .icon{
                transform: translateY(20px);
            }
        }

        .show-content{
            position: relative;
            z-index: 10;
        }

        .info-box{
            position: absolute;
            right: -22px;
            width: 0;
            top: 0;
            overflow: hidden;
            transition: all .3s ease-in-out;
            z-index: 5;
            opacity: .3;
            .content-box{
                padding: 22px 0;
                background: #daeeffe9;
                border-radius: 30px 0px 0px 30px;
                border: 1px solid rgba(200, 210, 233, 1);
                width: 272px;
                padding-left: 32px;
                overflow: hidden;
                .text{
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 15px;
                    color: rgba(77,143,204,0.8);
                }
            }
        }

    }

    .cloud-chain-no1{
        .show-content{
            min-height: 45px;
            position: relative;
            justify-content: end;
            .title{
                color: rgba(12,133,232,0.8);
            }
            >.icon{
                position: absolute;
                bottom: 0;
                transition: all .3s ease-in-out;

                &:hover{
                    transform: scale(1.1) translateY(-5px);
                }
            }
        }

    }
}
</style>

<style lang="scss">
.el-popover.el-popper.consult-popover{
    transform: translateX(-30px);
}
</style>



// WEBPACK FOOTER //
// src/components/FloatContent/index.vue